import { Divider, Flex, Stack, Text } from '@chakra-ui/react'
import Pagination from '@components/pagination'
import React, { useState } from 'react'
import { useReviews } from '../../common/hooks/useReviews'
import ReviewDetail from './review-detail'

interface ReviewsProps {
  productId: string
}

const Reviews: React.FC<ReviewsProps> = ({ productId }) => {
  const [currentPage, setCurrentPage] = useState<number>(1)
  const pageSize = 10

  const { reviews, total, isLoading } = useReviews({
    productId,
    currentPage,
    limit: pageSize
  })

  const totalPages = Math.ceil(total / pageSize)

  const displayReviewDetail = () => {
    if (reviews && reviews.length > 0) {
      return reviews.map((review) => (
        <ReviewDetail key={review.id} {...review} />
      ))
    }
    return (
      <Text
        fontWeight={500}
        fontStyle="italic"
        textColor="gray.800"
        textStyle="body"
      >
        No reviews yet. Purchase this product and be the first to review it!
      </Text>
    )
  }

  return (
    <Stack spacing={5}>
      <Text textStyle="ourStoryTitle" mb={2}>
        Reviews
      </Text>
      <Divider />
      <Stack gap={10} mt={3}>
        {isLoading ? <Text>Loading...</Text> : displayReviewDetail()}
      </Stack>
      <Flex justifyContent="center">
        <Pagination
          currentPage={currentPage}
          totalCount={totalPages}
          pageSize={pageSize}
          setCurrentPage={setCurrentPage}
          scrollOptions={{}}
        />
      </Flex>
    </Stack>
  )
}

export default Reviews
